
import { createStyles } from "../../lib/helpers";

const styles=createStyles( {

    image:{
        justifyContent:"center",
        alignItems:"center",
        overflow:"hidden",
        borderRadius:"50%",
        border:"1px solid black",
       // boxShadow:"px 2px  black"
    }
    ,
  
})
export default styles